var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2F4858",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#2F4858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27.9999 51.9063 C 41.0546 51.9063 51.9063 41.0781 51.9063 28 C 51.9063 14.9453 41.0312 4.0937 27.9765 4.0937 C 14.8983 4.0937 4.0937 14.9453 4.0937 28 C 4.0937 41.0781 14.9218 51.9063 27.9999 51.9063 Z M 21.5780 38.0781 C 20.3827 38.0781 19.5390 37.2109 19.5390 36.1094 C 19.5390 35.1953 19.9140 34.6094 20.9687 34.1406 L 33.4374 28 L 33.4374 27.8594 L 20.9687 21.5781 C 19.9609 21.0625 19.5390 20.4766 19.5390 19.5859 C 19.5390 18.5078 20.3593 17.6406 21.5077 17.6406 C 22.0468 17.6406 22.3749 17.7344 22.7733 17.9219 L 37.4218 25.8437 C 38.3827 26.3828 38.8749 27.0859 38.8749 28 C 38.8749 29.0078 38.4530 29.6406 37.4218 30.1563 L 22.7733 37.7734 C 22.3983 37.9844 22.0468 38.0781 21.5780 38.0781 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMenuIcon);
export default __webpack_public_path__ + "static/media/userMenuIcon.7b3f7ce7fc218f7348c225a335247f45.svg";
export { ForwardRef as ReactComponent };